import { getUsersByIds } from './GetUsersByIds';
import { getInternalUsers } from './GetInternalUsers';
import { getInternalUserMe } from './GetInternalUserMe';
import { getInternalUsersByRole } from './GetInternalUsersByRole';
import { getChildOffices } from './GetChildOffices';
import { getOffice } from './GetOffice';
import { getNpsReviews } from './GetNpsReviews';
import { searchOfficeUsers } from './SearchOfficeUsers';
import { getIdentityLocationCounts } from './GetIdentityLocationCounts';
import { getIdentityLocations } from './GetIdentityLocations';
import { updateUser } from './UpdateUser';

// The role slugs belong to the endpoint, so both the thunk that consumes the
// service and any hook that consumes it read them from here.
export { InternalUserRoles, INTERNAL_USERS_PAGE_LIMIT } from './GetInternalUsersByRole';
export {
  INTERNAL_USERS_DEFAULT_LIMIT,
  INTERNAL_USERS_MAX_LIMIT,
} from './GetInternalUsers';
export { INTERNAL_USER_ME_ENDPOINT } from './GetInternalUserMe';
export { LOCATION_COUNTS_MAX_IDS } from './GetIdentityLocationCounts';
export { MAX_USER_IDS_PER_REQUEST } from './GetUsersByIds';

/**
 * Users API Client
 * Provides low-level HTTP calls to user endpoints
 */
export const UsersApi = {
  getUsersByIds,
  getInternalUsers,
  getInternalUserMe,
  getInternalUsersByRole,
  getChildOffices,
  getOffice,
  getNpsReviews,
  searchOfficeUsers,
  getIdentityLocationCounts,
  getIdentityLocations,
  updateUser,
};
